import api from '../../utils/api';
import { getUsers } from './api/retailers';
import { alertError, alertSuccess } from './alert';
import { ADMIN_USERS, ADMIN_USERS_LOADING } from '../constants/adminUsersTypes';
import { getSupplierAdminUsers } from './supplierAdminUsers';

const setAdminUsers = (data) => ({ type: ADMIN_USERS, payload: data });
const setAdminUsersLoading = (value) => ({ type: ADMIN_USERS_LOADING, payload: value });

export const getAdminUsers =
  (showLoading = true) =>
  async (dispatch, getState) => {
    if (showLoading) {
      dispatch(setAdminUsersLoading(true));
    }

    const { retailerId } = getState().role;

    try {
      const response = await getUsers(retailerId);
      dispatch(setAdminUsers(response.data));
    } catch (error) {
      dispatch(alertError(error));
      dispatch(setAdminUsersLoading(false));
    }
  };

export const deleteAdminUsers = (id) => async (dispatch, getState) => {
  const { retailerId } = getState().role;

  try {
    const response = await deleteUser(retailerId, id);

    if (response.data.success) {
      dispatch(alertSuccess('Success'));
      dispatch(getAdminUsers(false));
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const deleteAdminUsersNotRegistered = (email) => async (dispatch, getState) => {
  const { retailerId, retailer } = getState().role;

  try {
    const response = await deleteUserNotRegistered(retailerId, email);

    if (response.data.success) {
      dispatch(alertSuccess(`User with email ${email} was successfully uninvited to ${retailer.name}.`));
      dispatch(getAdminUsers(false));
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const putAdminUsers = (userId, permissions) => async (dispatch, getState) => {
  const { retailerId } = getState().role;

  try {
    const responsePermissions = await updateUserPermissions(retailerId, userId, permissions);

    if (responsePermissions.data.success || responsePermissions.status === 204) {
      // for PUT with status 204
      dispatch(alertSuccess('Success'));
      dispatch(getAdminUsers(false));
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const putAdminUsersNotRegistered = (email, permissions) => async (dispatch, getState) => {
  const { retailerId } = getState().role;

  try {
    const responsePermissions = await updateUserNotRegisteredPermissions(retailerId, email, permissions);

    if (responsePermissions.data.success || responsePermissions.status === 204) {
      // for PUT with status 204
      dispatch(alertSuccess('Success'));
      dispatch(getAdminUsers(false));
    } else {
      dispatch(alertError('Error'));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export const addUser = (data) => async (dispatch, getState) => {
  const { retailerId, retailer } = getState().role;

  try {
    const response = await addAdminUser(retailerId, data);

    if (response.data.success) {
      dispatch(getAdminUsers(false));
      dispatch(alertSuccess(`User with email ${data.email} was successfully invited to ${retailer.name}.`));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

let cancelUpdateUserPermissions;
const updateUserPermissions = (retailerId, id, data) => {
  if (cancelUpdateUserPermissions) {
    cancelUpdateUserPermissions('Cancel update user permissions');
  }

  return api.put(`/retailers/${retailerId}/users/${id}`, data, {
    cancelToken: new api.CancelToken((c) => (cancelUpdateUserPermissions = c)),
  });
};

let cancelUpdateNotRegisteredUserPermissions;
const updateUserNotRegisteredPermissions = (retailerId, email, data) => {
  if (cancelUpdateNotRegisteredUserPermissions) {
    cancelUpdateNotRegisteredUserPermissions('Cancel update user permissions');
  }

  return api.put(`/retailers/${retailerId}/user_invitations/${email}`, data, {
    cancelToken: new api.CancelToken((c) => (cancelUpdateNotRegisteredUserPermissions = c)),
  });
};

let cancelDeleteUser;
const deleteUser = (retailerId, id) => {
  if (cancelDeleteUser) {
    cancelDeleteUser('Cancel delete user');
  }

  return api.delete(`/retailers/${retailerId}/users/${id}`, {
    cancelToken: new api.CancelToken((c) => (cancelDeleteUser = c)),
  });
};

let cancelDeleteUserNotRegistered;
const deleteUserNotRegistered = (retailerId, email) => {
  if (cancelDeleteUserNotRegistered) {
    cancelDeleteUserNotRegistered('Cancel delete user');
  }

  return api.delete(`/retailers/${retailerId}/user_invitations/${email}`, {
    cancelToken: new api.CancelToken((c) => (cancelDeleteUserNotRegistered = c)),
  });
};

let cancelAdd;
const addAdminUser = (retailerId, data) => {
  if (cancelAdd) {
    cancelAdd('Cancel add user');
  }

  return api.post(`/retailers/${retailerId}/users`, data, {
    cancelToken: new api.CancelToken((c) => (cancelAdd = c)),
  });
};

export const unblockUser = (userId, role) => async (dispatch) => {
  try {
    const response = await api.post(`/users/unblock-user/${userId}`);
    if (response.data.success) {
      dispatch(alertSuccess('User Unblocked Successfully'));
      if (role === 'retailer') {
        dispatch(getAdminUsers(false));
      } else {
        dispatch(getSupplierAdminUsers(false));
      }
    }
  } catch (e) {
    dispatch(alertError(e));
  }
};
